class CareersComponent extends HTMLElement {
  constructor() {
    super()

    this.querySelectorAll('.job-listing').forEach((listing) => {
      const trigger = listing.querySelector('.job-listing__title')
      const content = listing.querySelector('.job-listing__content')

      if (!trigger || !content) return

      trigger.addEventListener('click', () => {
        this.toggleListing(listing, trigger, content)
      })
    })
  }

  toggleListing(listing, trigger, content) {
    const isExpanded = trigger.getAttribute('aria-expanded') === 'true'

    listing.classList.toggle('active', !isExpanded)
    trigger.setAttribute('aria-expanded', `${!isExpanded}`)
    content.hidden = isExpanded
  }
}

customElements.define('careers-component', CareersComponent)
